import { Link } from 'react-router-dom'
import { useUser } from '@clerk/react'
import { Mail, Send } from 'lucide-react'

const cards = [
  {
    to: '/newsletters/new',
    title: 'New newsletter',
    body: 'Compose a newsletter — title, cover image, markdown body, schedule.',
    icon: Mail,
  },
  {
    to: '/push',
    title: 'Send a push',
    body: 'Title, body, and a deep link to a recipe / cut / newsletter.',
    icon: Send,
  },
]

export function Dashboard() {
  const { user } = useUser()
  return (
    <div>
      <header className="mb-10">
        <h1 className="font-serif text-3xl font-semibold text-marrow-900 dark:text-bone-50">
          Welcome back, {user?.firstName ?? 'admin'}.
        </h1>
        <p className="mt-2 text-sm text-marrow-800/70 dark:text-bone-200/70">
          Author a newsletter or push a notification to the iOS app.
        </p>
      </header>
      <div className="grid gap-4 sm:grid-cols-2">
        {cards.map(({ to, title, body, icon: Icon }) => (
          <Link
            key={to}
            to={to}
            className="group rounded-2xl border border-bone-200 bg-white p-6 transition hover:border-rust-500/60 hover:shadow-md dark:border-marrow-700 dark:bg-marrow-800"
          >
            <Icon className="mb-3 text-rust-500" size={22} aria-hidden />
            <h2 className="font-serif text-lg font-semibold text-marrow-900 dark:text-bone-50">
              {title}
            </h2>
            <p className="mt-1 text-sm text-marrow-800/70 dark:text-bone-200/70">{body}</p>
          </Link>
        ))}
      </div>
    </div>
  )
}
